var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-toggle',{class:{'low-toggle-height' : _vm.lowHeight},attrs:{"disable":_vm.isDisabled,"value":_vm.value,"val":_vm.val,"checked-icon":_vm.checkedIcon,"unchecked-icon":_vm.uncheckedIcon,"label":_vm.label},on:{"input":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }